


































































































































































































































































































import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { Choice } from "@/types";
import AnswerContent from "@/components/inquiry/answerContent.vue";
import {
  ANSWER_STATUS,
  ANSWER_METHOD,
  ANSWER_ASSIGN,
  INQUIRY_PUBLISHED,
  ACCESS_CONFIRMS,
  ANSWER_COMPLETED_UNSOLVED,
  ANSWER_COMPLETED,
} from "@/consts/inquiry";
import { AdminUser } from "@/model/adminUser";
import TrumbowygEditor from "@/components/trumbowyg/TrumbowygEditor.vue";
import InquiryAnswerFileUploader from "@/components/inquiry/InquiryAnswerFileUploader.vue";
import AnswerInfo from "@/components/inquiry/AnswerInfo.vue";
import InquirySimpleViewer from "@/components/inquiry/InquirySimpleViewer.vue";
import AttachmentViewer from "@/components/admin_common/AttachmentViewer.vue";
import ZeroDispNumberInput from "#/components/ZeroDispNumberInput.vue";

import {
  InquiryDiv,
  InquiryGroup,
  InquirySubGroup,
  InquiryServiceDiv,
  DispInquiry,
  DispInquiryAnswer,
  DEFAULT_DISP_INQUIRY,
  DEFAULT_DISP_INQUIRY_ANSWER,
  DEFAULT_OFFICESTAFF_CONTACT,
  OfficestaffContact,
} from "@/model/inquiry";
import UtilMixin from "@/mixins/utilMixin";
import RulesMixin from "#/mixins/rulesMixin";
import OfficestaffContactInfo from "@/components/inquiry/OfficestaffContactInfo.vue";

interface SelectableChoice extends Choice {
  /** 選択肢として使用できるかフラグ */
  selectable: boolean;
}

@Component({
  components: {
    AnswerContent,
    TrumbowygEditor,
    InquiryAnswerFileUploader,
    OfficestaffContactInfo,
    AttachmentViewer,
    ZeroDispNumberInput,
    AnswerInfo,
    InquirySimpleViewer,
  },
})
export default class AnswerForm extends Mixins(UtilMixin, RulesMixin) {
  /** FRT手動修正欄（空文字なら現在値を維持、入力があれば保存時に反映） */
  private manualFrt = "";

  @Watch("manualFrt")
  private onManualFrtChange(v: string) {
    // 入力があった時のみ inquiry.first_response_datetime を上書き。
    // 空文字（未入力）の場合は現在値を維持し、バックエンドで「変更なし」扱いになる。
    // AppDatetimePicker は分精度 "yyyy-MM-dd HH:mm" で emit するが、
    // FRT は秒精度で扱う仕様のため、送信前に ":00" を補完する。
    // Vue 2 のリアクティビティ保証のため $set を使う。
    if (v) {
      const value = v.length === 16 ? v + ":00" : v;
      this.$set(this.inquiry, "first_response_datetime", value);
    }
  }

  /** 回答情報 */
  @Prop({ default: () => DEFAULT_DISP_INQUIRY_ANSWER })
  inquiryAnswer!: DispInquiryAnswer;

  /** 初回問い合わせ */
  @Prop({ default: () => DEFAULT_DISP_INQUIRY })
  inquiry!: DispInquiry;

  /** 回答対象の問い合わせ+一連の問い合わせ */
  @Prop({ default: () => [] })
  inquiries!: DispInquiry[];

  /** アサインを選択できるかどうかフラグ */
  @Prop({ default: false }) assignable!: boolean;
  /** 合計回答対応時間 */
  @Prop({ default: 0 }) answerTime!: number;
  /** 管理者データ */
  @Prop({ default: () => [] }) adminUsers!: AdminUser[];
  /** 問い合わせ区分マスタデータ */
  @Prop({ default: () => [] }) inquiryDivs!: InquiryDiv[];
  /** 問い合わせサービス種類マスタデータ */
  @Prop({ default: () => [] }) inquiryServiceDivs!: InquiryServiceDiv[];

  /** 事業所職員コンタクト履歴 */
  @Prop({ default: () => DEFAULT_OFFICESTAFF_CONTACT })
  officestaffContact!: OfficestaffContact;

  /** 保存ボタン押した時用 */
  @Prop() isSaving!: boolean;

  /** ログイン中ユーザー名 */
  @Prop({ default: "" }) userName!: string;

  private isChangedServiceDivs = false;
  private isChangedInquiryDivs = false;
  private isChangedInquiryGroups = false;
  private isChangedInquirySubGroups = false;

  /** 回答ステータス */
  private ANSWER_STATUS = ANSWER_STATUS;
  /** 回答手段 */
  private ANSWER_METHOD = ANSWER_METHOD;
  private ANSWER_ASSIGN = ANSWER_ASSIGN;
  private ANSWER_COMPLETED = ANSWER_COMPLETED;
  private ANSWER_COMPLETED_UNSOLVED = ANSWER_COMPLETED_UNSOLVED;

  /** 公開設定選択肢 */
  private INQUIRY_PUBLISHED = INQUIRY_PUBLISHED;

  private ACCESS_CONFIRMS = ACCESS_CONFIRMS;

  private get innerAnswerTime() {
    return this.answerTime;
  }

  private set innerAnswerTime(value: number) {
    this.onChangeAnswerTime(value);
  }

  @Emit("answertime")
  private onChangeAnswerTime(value: number) {
    return value;
  }

  /** 回答ステータスの選択肢を生成 */
  private get FILTERED_ANSWER_STATUS() {
    // アサインを選択できるのは質問が1件もない状態で回答を起票する場合のみ
    if (this.assignable) {
      return this.ANSWER_STATUS.filter(
        (data: SelectableChoice) => data.selectable
      );
    }

    return this.ANSWER_STATUS.filter(
      (data: SelectableChoice) => data.value != ANSWER_ASSIGN && data.selectable
    );
  }

  /** 管理者選択肢 */
  private get adminUserChoices() {
    const choices: Choice[] = [];
    this.adminUsers.forEach((adminUser: AdminUser) => {
      choices.push({
        text: adminUser.last_name + adminUser.first_name,
        value: adminUser.id,
      });
    });

    return choices;
  }

  private formRequired = true;

  private get isValidServiceDivs() {
    if (
      this.inquiryAnswer.answer_status < ANSWER_COMPLETED ||
      this.inquiryAnswer.answer_status > ANSWER_COMPLETED_UNSOLVED
    ) {
      return true;
    }

    return (
      (!this.isChangedServiceDivs && !this.isSaving) ||
      this.inquiryAnswer.selected_service_divs.length
    );
  }

  private get isValidInquiryDivs() {
    if (
      this.inquiryAnswer.answer_status < ANSWER_COMPLETED ||
      this.inquiryAnswer.answer_status > ANSWER_COMPLETED_UNSOLVED
    ) {
      return true;
    }
    return (
      (!this.isChangedInquiryDivs && !this.isSaving) ||
      this.inquiryAnswer.selected_inquiry_divs.length
    );
  }

  private get isValidInquiryGroups() {
    if (
      this.inquiryAnswer.answer_status < ANSWER_COMPLETED ||
      this.inquiryAnswer.answer_status > ANSWER_COMPLETED_UNSOLVED
    ) {
      return true;
    }
    return (
      (!this.isChangedInquiryGroups && !this.isSaving) ||
      this.inquiryAnswer.selected_inquiry_groups.length
    );
  }

  private get isValidInquirySubGroups() {
    if (
      this.inquiryAnswer.answer_status < ANSWER_COMPLETED ||
      this.inquiryAnswer.answer_status > ANSWER_COMPLETED_UNSOLVED
    ) {
      return true;
    }

    // サブグループを持つ選択済みグループについて、それぞれ配下のサブグループが選択されているか
    const invalid = this.hydratedSelectedInquiryGroups.some((group) => {
      if (group.inquiry_sub_groups && group.inquiry_sub_groups.length > 0) {
        return !this.inquiryAnswer.selected_inquiry_sub_groups.some(
          (sg) => sg.inquiry_group_id === group.id
        );
      }
      return false;
    });

    return (!this.isChangedInquirySubGroups && !this.isSaving) || !invalid;
  }

  private serviceDivRule(): boolean | string {
    // 回答ステータスが対応完了系の場合はチェック必須
    if (
      this.inquiryAnswer.selected_service_divs.length == 0 &&
      this.inquiryAnswer.answer_status >= ANSWER_COMPLETED &&
      this.inquiryAnswer.answer_status <= ANSWER_COMPLETED_UNSOLVED
    ) {
      return "";
    }

    return true;
  }

  private inquiryDivRule(): boolean | string {
    // 回答ステータスが対応完了系の場合はチェック必須
    if (
      this.inquiryAnswer.selected_inquiry_divs.length == 0 &&
      this.inquiryAnswer.answer_status >= ANSWER_COMPLETED &&
      this.inquiryAnswer.answer_status <= ANSWER_COMPLETED_UNSOLVED
    ) {
      return "";
    }

    return true;
  }

  private inquiryGroupRule(): boolean | string {
    // 回答ステータスが対応完了系の場合はチェック必須
    if (
      this.inquiryAnswer.selected_inquiry_groups.length == 0 &&
      this.inquiryAnswer.answer_status >= ANSWER_COMPLETED &&
      this.inquiryAnswer.answer_status <= ANSWER_COMPLETED_UNSOLVED
    ) {
      return "";
    }

    return true;
  }

  private inquirySubGroupRule(group: InquiryGroup): boolean | string {
    // 回答ステータスが対応完了系で、サブグループの選択肢がある場合はチェック必須
    if (
      this.inquiryAnswer.answer_status >= ANSWER_COMPLETED &&
      this.inquiryAnswer.answer_status <= ANSWER_COMPLETED_UNSOLVED
    ) {
      if (
        this.isGroupSelected(group) &&
        group.inquiry_sub_groups &&
        group.inquiry_sub_groups.length > 0
      ) {
        const isSelected = this.inquiryAnswer.selected_inquiry_sub_groups.some(
          (sg) => sg.inquiry_group_id === group.id
        );
        if (!isSelected) {
          return "";
        }
      }
    }

    return true;
  }

  private onChangeAnswerStatus() {
    this.formRequired = this.inquiryAnswer.answer_status != ANSWER_ASSIGN;
    this.reset();
    this.isChangedServiceDivs = false;
    this.isChangedInquiryDivs = false;
    this.isChangedInquiryGroups = false;
    this.isChangedInquirySubGroups = false;
  }

  private get require(): boolean {
    return this.inquiryAnswer.answer_status != ANSWER_ASSIGN;
  }

  /** 公開設定に関するバリデーションチェック */
  private checkPublishStatus(): string | boolean {
    if (
      this.inquiryAnswer.answer_status === ANSWER_ASSIGN &&
      this.inquiryAnswer.is_published === 1
    ) {
      return "回答ステータスがアサインの場合は回答を公開することができません。";
    }

    // システム回答で完了かつ非公開の場合はエラー
    if (
      this.inquiryAnswer.answer_div === 4 && // iBowシステム
      this.inquiryAnswer.answer_status === ANSWER_COMPLETED && // 対応完了
      this.inquiryAnswer.is_published === 0 // 非公開
    ) {
      return "回答方法がシステム回答の場合、ステータス「完了」かつ公開設定「非公開」の組み合わせは選択できません。";
    }

    return true;
  }

  @Emit("reset")
  private reset() {
    return;
  }

  /** 事業所職員コンタクト履歴保存 */
  @Emit("officestaffcontact")
  private saveOfficestaffContact(data: OfficestaffContact) {
    return data;
  }

  /** 指定したサービス種類が選択されているか */
  private isServiceSelected(service: InquiryServiceDiv): boolean {
    return this.inquiryAnswer.selected_service_divs.some(
      (s) => s.id === service.id
    );
  }

  /** 指定した問い合わせグループが選択されているか */
  private isGroupSelected(group: InquiryGroup): boolean {
    return this.inquiryAnswer.selected_inquiry_groups.some(
      (g) => g.id === group.id
    );
  }

  /** 問い合わせグループエリアを表示すべきかどうか */
  private shouldShowGroupArea(service: InquiryServiceDiv): boolean {
    // グループがない場合は表示しない
    if (!service.inquiry_groups || service.inquiry_groups.length === 0) {
      return false;
    }
    // 選択されている、または is_open=1
    return this.isServiceSelected(service) || service.is_open === 1;
  }

  /** 表示対象の問い合わせグループ一覧 */
  private get visibleGroups(): InquiryGroup[] {
    const groups: InquiryGroup[] = [];
    this.inquiryAnswer.selected_service_divs.forEach((selectedService) => {
      // マスターからサービスを取得 (selected_service_divsが浅いため)
      const masterService = this.inquiryServiceDivs.find(
        (s) => s.id === selectedService.id
      );
      if (masterService && masterService.inquiry_groups) {
        groups.push(...masterService.inquiry_groups);
      }
    });
    // sort_no順に並び替え
    return groups.sort((a, b) => a.sort_no - b.sort_no);
  }

  /**
   * 選択された問い合わせグループにマスターデータの階層構造（サブグループなど）を付与して返す
   * (UI描画用。inquiryAnswer.selected_inquiry_groups自体は変更しない)
   */
  private get hydratedSelectedInquiryGroups(): InquiryGroup[] {
    if (
      !this.inquiryAnswer.selected_inquiry_groups ||
      !this.inquiryServiceDivs
    ) {
      return [];
    }

    // 全てのサービス配下の全グループをフラット化して検索用に準備
    const allMasterGroups: InquiryGroup[] = [];
    this.inquiryServiceDivs.forEach((service) => {
      if (service.inquiry_groups) {
        allMasterGroups.push(...service.inquiry_groups);
      }
    });

    return this.inquiryAnswer.selected_inquiry_groups.map((selectedGroup) => {
      const masterGroup = allMasterGroups.find(
        (g) => g.id === selectedGroup.id
      );

      if (!masterGroup) {
        return selectedGroup;
      }

      // マスターデータの情報（inquiry_sub_groupsなど）をマージして返す
      // 参照を切り離して新しいオブジェクトとして返す
      return {
        ...selectedGroup,
        inquiry_sub_groups: masterGroup.inquiry_sub_groups,
      };
    });
  }

  /** 表示対象の問い合わせサブグループ一覧 */
  private get visibleSubGroups(): InquirySubGroup[] {
    const subGroups: InquirySubGroup[] = [];
    // 浅い selected_inquiry_groups ではなく、hydratedSelectedInquiryGroups を使うことで
    // グループ配下のサブグループ定義にアクセスできるようにする
    this.hydratedSelectedInquiryGroups.forEach((group) => {
      // 選択されているグループかつ、visibleGroupsに含まれているもののみ対象
      // (親のサービスが解除されたがselected_inquiry_groupsに残っている場合を除外するため)
      if (
        this.visibleGroups.some((g) => g.id === group.id) &&
        group.inquiry_sub_groups
      ) {
        subGroups.push(...group.inquiry_sub_groups);
      }
    });
    return subGroups.sort((a, b) => a.sort_no - b.sort_no);
  }

  /** 表示すべきサブグループが存在するかどうか */
  private get hasVisibleSubGroups(): boolean {
    // hydratedSelectedInquiryGroups を使うことで、サブグループ定義の有無を正しく判定
    return this.hydratedSelectedInquiryGroups.some(
      (group) => group.inquiry_sub_groups && group.inquiry_sub_groups.length > 0
    );
  }

  /** サービス種類変更時 */
  private onChangeServiceDivs() {
    this.isChangedServiceDivs = true;

    // 選択解除されたサービスに紐づくグループの選択を解除
    this.inquiryAnswer.selected_inquiry_groups =
      this.inquiryAnswer.selected_inquiry_groups.filter((group) =>
        this.visibleGroups.some((g) => g.id === group.id)
      );

    // グループ解除に伴いサブグループも解除する必要があるため呼び出し
    this.onChangeInquiryGroups();
  }

  /** 問い合わせグループ変更時 */
  private onChangeInquiryGroups() {
    this.isChangedInquiryGroups = true;

    // 選択解除されたグループに紐づくサブグループの選択を解除
    this.inquiryAnswer.selected_inquiry_sub_groups =
      this.inquiryAnswer.selected_inquiry_sub_groups.filter((subGroup) =>
        this.visibleSubGroups.some((sg) => sg.id === subGroup.id)
      );

    // グループ選択時に親サービスが未選択なら選択する
    const selectedGroupIds = this.inquiryAnswer.selected_inquiry_groups.map(
      (g) => g.id
    );
    this.inquiryServiceDivs.forEach((service) => {
      if (
        service.inquiry_groups &&
        service.inquiry_groups.some((g) => selectedGroupIds.includes(g.id))
      ) {
        if (!this.isServiceSelected(service)) {
          this.inquiryAnswer.selected_service_divs.push(service);
          this.isChangedServiceDivs = true;
        }
      }
    });
  }
}
